// extracted by mini-css-extract-plugin
export var disabled = "_1g-5";
export var error = "_1g-1";
export var fitContent = "_1g-6";
export var hasSuffix = "_1g-4";
export var iconWrapper = "_1g-b";
export var infoIconWrapper = "_1g-d _1g-b";
export var input = "_1g-a";
export var inputWrapper = "_1g-0";
export var large = "_1g-8";
export var leadingIconWrapper = "_1g-c _1g-b";
export var measureBox = "_1g-e";
export var medium = "_1g-7";
export var readonly = "_1g-2";
export var small = "_1g-3";
export var suffix = "_1g-9";